var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAnalyzedIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 125.813,
    height: 68.639,
    viewBox: "0 0 125.813 68.639",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M564.9,463.858H538.677L533.25,452.1a5.683,5.683,0,0,0-10.4,0L508.83,482.4l-15.6-42.96a5.937,5.937,0,0,0-4.974-3.844,5.684,5.684,0,0,0-5.427,3.164l-12.663,24.872H451.4a5.653,5.653,0,0,0,0,11.306h22.159a5.2,5.2,0,0,0,4.976-3.166l8.365-16.28,15.827,43.867a5.894,5.894,0,0,0,5.2,3.844h.225a5.713,5.713,0,0,0,5.2-3.393l14.7-31.882,1.81,3.844a5.711,5.711,0,0,0,5.2,3.393H564.9a5.6,5.6,0,0,0,5.654-5.654A5.744,5.744,0,0,0,564.9,463.858Z",
    transform: "translate(-445.245 -435.062)",
    fill: "rgba(var(--secondaryColorRGB),0.2)",
    stroke: "var(--secondaryColor)",
    strokeWidth: 1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnalyzedIcon);
export default __webpack_public_path__ + "static/media/analyzed-icon.0a6bdc50fbd2e5787a67536b413e1c80.svg";
export { ForwardRef as ReactComponent };